import React from 'react';
import './PlanBox.css'; // You'll need to create this CSS file

const PlanBox = ({
                     planName,
                     description,
                     price,
                     duration,
                     billingFrequency,
                     details,
                     isPopular,
                     isDisabled
                 }) => {
    return (
        <div className="plan-box">
            <div className='popular-div'>
                <h3 className="plan-name">{planName}</h3>
                {isPopular && <span className="popular-tag">Popular</span>}

            </div>
            <h4>{details.title}</h4>
            <p>{description}</p>
            <div className="price-container">
                <div className="price-info">
                    <div className="price-amount">
                        <span className="currency">US$</span>
                        <span className="amount">{price}</span>
                    </div>
                    <div className="price-details">
                        <span className="duration">{duration}</span>
                        <span className="billing-frequency">{billingFrequency}</span>
                    </div>
                </div>
            </div>

            <div className="plan-details">

                <ul>
                    {details.items.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default PlanBox;